import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 300 300",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "b",
				width: 207,
				height: 134,
				x: 35,
				y: 147,
				maskUnits: "userSpaceOnUse",
				style: { maskType: "alpha" },
				children: /* @__PURE__ */ _jsx("path", {
					fill: "#fecfc4",
					d: "m234.711 185.486-53.942 8.041c-2.602-11.654-3.985-17.461-4.895-21.633-3.805-17.332-18.864-23.278-23.035-24.595-.524 3.142-18.828 14.026-27.135 9.051-30.41 39.705-49.167 65.653-89.356 103.692-6.18 5.73 11.82 25.41 18.03 19.769 38.678-34.656 59.24-53.624 88.411-89.13l-5.639-18.721 24.181 41.546a16.67 16.67 0 0 0 7.395 6.728 16.67 16.67 0 0 0 9.915 1.283l60.602-10.921c5.431-.886 1.031-26.114-4.532-25.11"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#b)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M34.512 163.617h13.13v-13.129h-13.13zm0 13.13h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M34.512 150.487h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M60.771 150.487h13.13v-13.129H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M47.642 150.487h13.13v-13.129h-13.13zm39.388 13.13h13.13v-13.129H87.03zm-39.388 0h13.13v-13.129h-13.13zm39.388 13.13h13.13v-13.13H87.03zm-13.13 0h13.13v-13.13H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M87.03 150.487h13.13v-13.129H87.03zm-13.13 0h13.13v-13.129H73.9zm0 13.13h13.13v-13.129H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M60.771 163.617h13.13v-13.129H60.77zm0 13.13h13.13v-13.13H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M47.642 176.747h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M165.808 150.487h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13zm39.389 13.13h13.13v-13.129h-13.13zm-39.389 0h13.13v-13.129h-13.13zm39.389 13.13h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M192.067 150.487h13.13v-13.129h-13.13zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.129h-13.13zm-13.129 0h13.129v-13.129h-13.129zm0 13.13h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M113.289 150.487h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M100.16 150.487h13.13v-13.129h-13.13zm39.389 13.13h13.129v-13.129h-13.129zm-39.389 0h13.13v-13.129h-13.13zm39.389 13.13h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M139.549 150.487h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.129h-13.13zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M100.16 176.747h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M218.326 150.487h13.13v-13.129h-13.13zm-13.129 0h13.129v-13.129h-13.129zm0 13.13h13.129v-13.129h-13.129zm26.259 13.13h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M231.456 150.487h13.129v-13.129h-13.129zm0 13.13h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M34.512 203.006h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M34.512 189.876h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M60.771 189.876h13.13v-13.129H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M47.642 189.876h13.13v-13.129h-13.13zm39.388 13.13h13.13v-13.13H87.03zm-39.388 0h13.13v-13.13h-13.13zm39.388 13.129h13.13v-13.129H87.03zm-13.13 0h13.13v-13.129H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M87.03 189.876h13.13v-13.129H87.03zm-13.13 0h13.13v-13.129H73.9zm0 13.13h13.13v-13.13H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M60.771 203.006h13.13v-13.13H60.77zm0 13.129h13.13v-13.129H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M47.642 216.135h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M165.808 189.876h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13zm39.389 13.13h13.13v-13.13h-13.13zm-39.389 0h13.13v-13.13h-13.13zm39.389 13.129h13.13v-13.129h-13.13zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M192.067 189.876h13.13v-13.129h-13.13zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129zm0 13.129h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M113.289 189.876h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M100.16 189.876h13.13v-13.129h-13.13zm39.389 13.13h13.129v-13.13h-13.129zm-39.389 0h13.13v-13.13h-13.13zm39.389 13.129h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M139.549 189.876h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13zm0 13.13h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M100.16 216.135h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M218.326 189.876h13.13v-13.129h-13.13zm-13.129 0h13.129v-13.129h-13.129zm0 13.13h13.129v-13.13h-13.129zm26.259 13.129h13.129v-13.129h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M231.456 189.876h13.129v-13.129h-13.129zm0 13.13h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13zm-13.129 0h13.129v-13.129h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M34.512 242.395h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M34.512 229.265h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M60.771 229.265h13.13v-13.13H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M47.642 229.265h13.13v-13.13h-13.13zm39.388 13.13h13.13v-13.13H87.03zm-39.388 0h13.13v-13.13h-13.13zm39.388 13.129h13.13v-13.129H87.03zm-13.13 0h13.13v-13.129H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M87.03 229.265h13.13v-13.13H87.03zm-13.13 0h13.13v-13.13H73.9zm0 13.13h13.13v-13.13H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M60.771 242.395h13.13v-13.13H60.77zm0 13.129h13.13v-13.129H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M47.642 255.524h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M165.808 229.265h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13zm39.389 13.13h13.13v-13.13h-13.13zm-39.389 0h13.13v-13.13h-13.13zm39.389 13.129h13.13v-13.129h-13.13zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M192.067 229.265h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13zm0 13.13h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129zm0 13.129h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M113.289 229.265h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M100.16 229.265h13.13v-13.13h-13.13zm39.389 13.13h13.129v-13.13h-13.129zm-39.389 0h13.13v-13.13h-13.13zm39.389 13.129h13.129v-13.129h-13.129zm-13.13 0h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M139.549 229.265h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13zm0 13.13h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M100.16 255.524h13.13v-13.129h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M218.326 229.265h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129zm0 13.13h13.129v-13.13h-13.129zm26.259 13.129h13.129v-13.129h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M231.456 229.265h13.129v-13.13h-13.129zm0 13.13h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13zm0 13.129h13.13v-13.129h-13.13zm-13.129 0h13.129v-13.129h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M34.512 281.783h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M34.512 268.654h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M60.771 268.654h13.13v-13.13H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M47.642 268.654h13.13v-13.13h-13.13zm39.388 13.129h13.13v-13.13H87.03z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M47.642 281.783h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M87.03 268.654h13.13v-13.13H87.03zm-13.13 0h13.13v-13.13H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M73.9 281.783h13.13v-13.13H73.9z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M60.771 281.783h13.13v-13.13H60.77z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M165.808 268.654h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13zm39.389 13.129h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M152.678 281.783h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M192.067 268.654h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M178.937 281.783h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M113.289 268.654h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M100.16 268.654h13.13v-13.13h-13.13zm39.389 13.129h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M100.16 281.783h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M139.549 268.654h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M126.419 281.783h13.13v-13.13h-13.13zm-13.13 0h13.13v-13.13h-13.13z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M218.326 268.654h13.13v-13.13h-13.13zm-13.129 0h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#ff80e0",
						d: "M205.197 281.783h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M231.456 268.654h13.129v-13.13h-13.129z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#251d97",
						d: "M231.456 281.783h13.129v-13.13h-13.129zm-13.13 0h13.13v-13.13h-13.13z"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fecfc4",
				d: "m100.289 53.926-9.06-42.089-13.951 3a3.922 3.922 0 0 0-1.5 6.93 8.896 8.896 0 1 1-13.29 2.88 3.913 3.913 0 0 0-4.23-5.67l-13.02 2.79 9.065 42.09a3.837 3.837 0 0 0 4.56 2.94l21.39-4.59c.2-2.17.59-6.607 1.62-7.98 1.17-1.56 2.01 3.631 2.58 7.05l12.9-2.79a3.837 3.837 0 0 0 2.936-4.56"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6153bd",
				d: "m138.179 96.107-2.872 3.27a9.4 9.4 0 0 0-.594-2.19 19.5 19.5 0 0 0 3.466-1.08m20.879 28.532a59 59 0 0 0-2.22 7.47c3.721.149 3.961.239 7.501.239zm-12.382 61.86c-1.02 1.29-2.07 2.55-3.06 3.81l-5.639-18.721zm2.902-108.721c-9.534-10.921-15.359-5.88-18.535.36 3.361-6.36 8.669-4.44 9.869 2.58.12.81.57.75.66.69.481-.128.93-.352 1.32-.66 2.791-1.95 4.711 2.94.54 4.35a61 61 0 0 0-.93 9.179s17.307-4.823 7.076-16.5"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#6153bd",
				d: "M160.619 75.108c-3.54 3.69-9.083 4.132-12.391.96-3.308-3.173-3.12-8.73.42-12.421s9.083-4.132 12.391-.96 3.12 8.73-.42 12.42M36.301 265.4c-18.231 14.328-29.37 20.262-29.074 22.65.631 5.13 19.47-3.27 28.92-2.49 2.237.235 4.5.031 6.66-.6 2.43-.75 4.263-2.791 6.6-5.161A27.13 27.13 0 0 1 36.301 265.4m218.223-76.231c-6.646-4.607-9.474-3-15.57-1.41a35.65 35.65 0 0 1 3.391 18.99c7.708-1.079 16.829-2.191 22.469-2.527 8.191-.474 15.36-1.198 15.931-2.55 2.043-4.732-18.484-7.044-26.221-12.503m-27.067-84.605-6.358.632c1.44-4.139 4.168-4.442 6.358-.632m1.202 18.245c-1.41 3.12-3.66 3.24-5.58.45zm-41.161-76.831a1.035 1.035 0 0 1-1.23-.81l-2.55-12.475a1.03 1.03 0 0 1 .795-1.216 1.03 1.03 0 0 1 1.215.796l2.551 12.474a1 1 0 0 1-.122.787 1 1 0 0 1-.659.444m-68.7 74.281-4.737 11.549c1.08.09 2.19.15 3.27.21-.6-3.98-.095-8.049 1.467-11.759M2.396 163.698a1.405 1.405 0 0 1-1.945-.004 1.4 1.4 0 0 1-.065-1.945 1.405 1.405 0 0 1 1.946.003 1.4 1.4 0 0 1 .064 1.946m135.693-48.21a1.64 1.64 0 0 1-.358 1.204 1.62 1.62 0 0 1-1.109.59 1.63 1.63 0 0 1-1.772-1.494 1.63 1.63 0 0 1 1.472-1.745 1.627 1.627 0 0 1 1.767 1.445m-2.64 10.951c.019.213-.003.427-.066.631a1.65 1.65 0 0 1-.796.958 1.625 1.625 0 0 1-1.798-.189 1.62 1.62 0 0 1-.58-1.102 1.625 1.625 0 0 1 1.471-1.769 1.625 1.625 0 0 1 1.769 1.471m0 12.239a1.7 1.7 0 0 1-.066.632 1.64 1.64 0 0 1-.796.957c-.189.1-.396.161-.609.18a1.6 1.6 0 0 1-1.189-.369 1.62 1.62 0 0 1-.58-1.101 1.626 1.626 0 1 1 3.24-.299"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "m57.934 277.009 39.95 15.541 11.009-28.35a8.93 8.93 0 0 1 7.769-5.529 8.93 8.93 0 0 1 8.337 4.629 20.3 20.3 0 0 0 19.111 10.55 20.32 20.32 0 0 0 17.624-12.881 20.297 20.297 0 0 0-25.454-26.589 8.929 8.929 0 0 1-11.281-11.551l7.44-19.106M33.567 267.53l-27.99-10.895a8.75 8.75 0 0 1-4.98-11.33l32.58-83.736a8.74 8.74 0 0 1 4.637-4.841 8.75 8.75 0 0 1 6.703-.139l62.846 24.42m148.386-73.201c.187.715.469 1.402.84 2.04m-.923-6.209a8.92 8.92 0 0 1 4.464-6 20.3 20.3 0 0 0 10.094-13.386 20.3 20.3 0 0 0-3.418-16.414 20.3 20.3 0 0 0-20.335-7.928A20.296 20.296 0 0 0 231.21 86.36a8.94 8.94 0 0 1-2.202 9.3 8.92 8.92 0 0 1-9.349 1.979l-30.36-11.79-7.895 20.31m40.145 107.407 20.369 7.896a8.76 8.76 0 0 0 6.703-.139 8.76 8.76 0 0 0 4.637-4.842l4.598-11.83m.952-92.181c.685.534 1.443.97 2.25 1.291l19.771 7.65a8.74 8.74 0 0 1 4.979 11.339l-23.353 60.071m-108.042-49.313a9.14 9.14 0 0 1 8.306 7.53m-41.821-44.791a20.37 20.37 0 0 1 14.311-6.03m10.919-31.95-46.65-18.12m70.951 56.491 9.809-25.08-18.719-7.29m-46.711 97.05-65.82-25.59a8.776 8.776 0 0 1-4.98-11.341l8.76-22.709a9.022 9.022 0 0 0-11.28-11.611 20.257 20.257 0 0 1-26.349-15.26 20.252 20.252 0 0 1 37.629-13.66c3.488 6.406 13.333 6.316 16.106-.87l1.2-3.09m64.631 30.005c1.195-.24 2.36-.611 3.474-1.105l-2.872 3.26"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M156.119 106.398a26.3 26.3 0 0 1-9.751-2.101c-2.005-1.087-3.959-3.06-3.87-10.02.079-3.08.39-6.147.93-9.179 4.17-1.38 2.288-6.247-.54-4.35-1.041.698-1.796 1.132-1.98 0-1.143-7.06-6.509-8.94-9.869-2.58l-1.05 2.43c-2.432 6.843-2.795 17.772 4.716 16.59.294.69.493 1.415.594 2.16.039.749-.782 4.768-1.68 5.28-1.833 1.045-5.01 2.04-10.711 1.77m100.124 16.935c16.404-1.436 19.591-2.426 30.159-4.005a56 56 0 0 0 3.781-.69c5.313-1.124 5.7-2.842-.51-2.76a32.7 32.7 0 0 1-9.331-1.23"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M249.389 115.193c.03.15 3.962-1.049 8.73-2.527 5.341-1.648 5.669-3.819-.81-2.91a29.3 29.3 0 0 1-9.9.18"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M246.27 106.248s11.727-3.247 12.449-3.474c5.527-1.789 6.36.211 1.65 2.73-4.32 2.31-10.08 4.737-10.08 4.737"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M221.006 105.207s7.503-.76 7.563-.76c2.19-.15 4.988-1.828 5.311-3.75.552-3.297.778-8.18 2.43-7.92 2.547.404 1.541 7.522 3.21 9.87.573.807 3.39 0 4.47-.45a735 735 0 0 0 8.279-3.57c5.317-2.452 6.008-.257 1.8 2.43a26.6 26.6 0 0 0-5.661 4.598"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M245.25 103.907a18.08 18.08 0 0 1 1.649 12.271m-4.499-9.9c-.39 4.86-2.527 8.22-7.081 9.12m-78.48 16.711a59 59 0 0 1 2.22-7.47l5.239 7.65m-20.701 57.981-5.628-18.682 8.699 14.911"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M126.538 155.959c-30.96 40.381-48.476 65.609-89.373 103.711-6.158 5.743 11.772 25.392 18.001 19.769l10.738-9.689c29.138-26.339 47.944-43.8 70.982-71.31 0 0 8.759-10.651 9.779-11.941l15.511 26.61a16.6 16.6 0 0 0 7.39 6.738 16.6 16.6 0 0 0 9.919 1.272l60.635-10.895c5.43-.905.933-26.076-4.59-25.107l-53.942 8.041s-4.195-18.475-4.895-21.661a32.83 32.83 0 0 0-22.979-24.633m-22.671-68.726c3.181-6.24 9.001-11.28 18.54-.36 10.199 11.67-7.08 16.53-7.08 16.53"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M160.619 75.108c-3.54 3.69-9.083 4.132-12.391.96-3.308-3.173-3.12-8.73.42-12.421s9.083-4.132 12.391-.96 3.12 8.73-.42 12.42M49.408 279.799c-2.34 2.369-4.175 4.396-6.6 5.161-2.161.63-4.422.833-6.661.6-9.452-.754-28.284 7.618-28.92 2.49-.179-1.44 5.61-5.701 12.45-10.264 4.32-2.88 10.861-7.859 16.62-12.389m202.653-77.638c3.81-.99 6.749-2.095 9.539-1.44a17.5 17.5 0 0 1 6.03 2.842c7.763 5.429 28.244 7.763 26.222 12.509-.575 1.349-7.738 2.072-15.931 2.551-5.641.331-14.761 1.44-22.47 2.526m-18.307-104.848c1.124-.093 2.343.79 3.425 2.666m1.201 18.244c-.66 1.44-1.56 2.34-2.58 2.43m-37.77-80.492a1.046 1.046 0 0 1-1.586 1.053 1.05 1.05 0 0 1-.455-.633l-2.55-12.474a1.035 1.035 0 0 1 .796-1.216 1.03 1.03 0 0 1 1.214.796zm-5.071-19.531 1.5 7.26m-5.19-25.289a9.194 9.194 0 0 0-7.347 8.613 9.2 9.2 0 0 0 3.937 7.953 9.2 9.2 0 0 0 9.836.428 9.2 9.2 0 0 0 2.78-13.502 9.2 9.2 0 0 0-9.206-3.492m110.371 168.361-3.51-1.05m7.771-1.29 1.02-3.51m-3.99 13.591 1.05-3.48m4.26-2.34 3.48 1.02m-3.474-1.021a3.44 3.44 0 0 1-2.34-4.263 3.444 3.444 0 0 1-4.264 2.34 3.45 3.45 0 0 1 2.341 4.264 3.45 3.45 0 0 1 4.263-2.341M73.527 77.928a65 65 0 0 1-3.96-13.44m10.621-2.311-21.36 4.59a3.837 3.837 0 0 1-4.56-2.94l-9.03-42.09 13.02-2.791a3.89 3.89 0 0 1 4.2 5.67 8.895 8.895 0 1 0 13.32-2.848 3.906 3.906 0 0 1 1.5-6.9l13.95-3.03 9.061 42.088a3.837 3.837 0 0 1-2.94 4.56l-12.931 2.79"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M79.287 74.088c-1.71-2.1-2.28-7.17.72-9.475 0 0 .4-8.482 1.86-10.409 1.461-1.926 2.28 6.054 2.91 9.083.416 1.982 1.5 6.57 2.58 10.35m26.713 58.136 4.758-11.527a22.16 22.16 0 0 0-1.5 11.759"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M224.033 101.899c-26.279 3.418-53.125 5.669-67.915 4.499-11.88 2.94-23.039 3.27-33.21 0-5.25-.24-12.6-1.621-22.95-5.071l-8.49-27.06c-.9-2.94-21.721 3.42-20.821 6.36l13.77 42.661a80.3 80.3 0 0 0 32.911 8.729c.72 5.161 3.21 12.451 9.21 23.942 6.451 3.84 20.37-1.65 27.002-8.551 1.17-5.4 2.22-10.77 3.3-15.299a262.6 262.6 0 0 0 69.211-6.87c-6.184.533-8.319-22.808-2.018-23.34m-179.52 150.75c-4.71 4.106 13.106 24.475 17.79 20.4m162.246-86.28c4.14-.75 8.761 24.689 4.62 25.44M206.28 257.96l-11.341 29.19m20.28-8.941-29.22-11.309M3.327 157.009c.6-1.71 1.68-2.73 4.8-4.86 6.605-4.51 5.369-9.681 1.47-11.221a5.06 5.06 0 0 0-4.265.293 5.05 5.05 0 0 0-2.515 3.457"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#120071",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: .769,
				d: "M53.008 269.149a1223 1223 0 0 0 87.12-90.452m6.548-26.039s16.046 7.081 17.551 19.95c.837 7.17 5.58 21.991 8.1 29.55a5.945 5.945 0 0 0 6.419 4.02l51.331-6.72"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h300v300H0z"
		})
	}) })]
});
export default SvgCreateNew;
